import type { VoidFunctionComponent } from 'react';

import { useQuery } from '../../../../contexts/RouterContext';
import type { SnippetsQueryParams } from '../../../../../shared/snippets';

import EmptyState from './EmptyState';
import Header from './Header';
import Layout from './Layout';

/**
 * Top-level Route component for the Snippets comparison view.
 */
const CompareSnippetsContainer: VoidFunctionComponent = () => {
  const [query] = useQuery<SnippetsQueryParams>();
  return (
    <div>
      <Header />

      {!query.olderRevisionLocator && (
        <EmptyState />
      )}

      {query.olderRevisionLocator && (
        <Layout olderRevisionLocator={query.olderRevisionLocator} />
      )}
    </div>
  );
};

export default CompareSnippetsContainer;
